import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityFlagsRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
});

const GetFacilityFlagsResponseDtoSchema = z.object({
  amount: z.number(),
  changePct: z.number().nullable(),
});

export type GetFacilityFlagsRequestDto = z.infer<
  typeof _GetFacilityFlagsRequestDtoSchema
>;
export type GetFacilityFlagsResponseDto = z.infer<
  typeof GetFacilityFlagsResponseDtoSchema
>;

export const getFacilityFlags = (
  params: GetFacilityFlagsRequestDto,
  config?: AxiosRequestConfig<GetFacilityFlagsRequestDto>
) => {
  const { facilityId, ...dateRange } = params;

  return api
    .get(`facilities/${facilityId}/flags`, { params: dateRange, ...config })
    .then(responseContract(GetFacilityFlagsResponseDtoSchema));
};
